import { PitchType } from '@mailings/components/creators/personalized-mailing-creator-wizard/types/mailingObjectivesForm.types';
import { getAnnouncementFormValidationSchema } from '@mailings/components/creators/personalized-mailing-creator-wizard/validations/getAnnouncementFormValidationSchema.validations';
import { getBaseObjectivesFormValidationSchema } from '@mailings/components/creators/personalized-mailing-creator-wizard/validations/getBaseObjectivesFormValidationSchema.validations';
import { getResearchFormValidationSchema } from '@mailings/components/creators/personalized-mailing-creator-wizard/validations/getResearchFormValidationSchema.validations';
import { getThoughtLeadershipFormValidationSchema } from '@mailings/components/creators/personalized-mailing-creator-wizard/validations/getThoughtLeadershipFormValidationSchema.validations';

export const getValidationSchemaForPitchType = (pitchType: PitchType) => {
  switch (pitchType) {
    case 'personalization_announcement':
      return getAnnouncementFormValidationSchema();
    case 'personalization_research':
      return getResearchFormValidationSchema();
    case 'personalization_leadership':
      return getThoughtLeadershipFormValidationSchema();
    default:
      return getBaseObjectivesFormValidationSchema();
  }
};
